
import {Component, Vue} from 'vue-property-decorator';
import AppDialog from '@/modules/Popup/components/AppDialog.vue';
import {IAccounts} from "@/modules/Profile/interfaces/accounts.interface";
import AccountForm from "@/modules/Profile/components/accounts/AccountForm.vue";

@Component({
  components: {
    AccountForm,
    AppDialog,
  },
})
export default class AccountPopup extends Vue {
  $refs: any;
  currentPopup = { blockName: 'profile', dialogName: 'accountPopup' };

  get payloadPopup(): IAccounts.IPopupPayload { return this.$store.getters['dialog/getPopupPayload'](this.currentPopup); }

  async onClose() {
    this.$refs.appDialog.onClose();
  }

}
